/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CloudProvidersEnum } from './cloudProvidersEnum';
import { ServiceTypeEnum } from './serviceTypeEnum';
import { IrrSaasCapabilities } from './irrSaasCapabilities';


export interface OperatorDeploymentImportSpec { 
    /**
     * Org id
     */
    org_id: string;
    service_type: ServiceTypeEnum;
    provider: CloudProvidersEnum;
    /**
     * Cloud Provider Region ID
     */
    region: string;
    /**
     * IP address of gateway
     */
    gateway_ip: string;
    capabilities?: IrrSaasCapabilities;
}
export namespace OperatorDeploymentImportSpec {
}


